export default "__VITE_ASSET__BqjSqHMf__"